import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Target, Lightbulb, Heart, Users, UserCheck, Settings } from 'lucide-react';

const StorySection = () => {
  const values = [
    {
      icon: <Heart className="h-8 w-8 text-red-500" />,
      title: "Leidenschaft für Code",
      description: "Wir lieben, was wir tun. Jede Zeile Code, jede Funktion wird mit Hingabe entwickelt."
    },
    {
      icon: <Users className="h-8 w-8 text-blue-500" />,
      title: "Partnerschaftlich",
      description: "Wir sind nicht nur Dienstleister, sondern langfristige Partner für den digitalen Erfolg."
    },
    {
      icon: <Target className="h-8 w-8 text-green-500" />,
      title: "Ergebnisorientiert",
      description: "Unser Erfolg misst sich am Erfolg unserer Kunden. Ihre Ziele sind unsere Ziele."
    },
    {
      icon: <Lightbulb className="h-8 w-8 text-yellow-500" />,
      title: "Innovativ",
      description: "Wir bleiben am Puls der Zeit und setzen moderne Technologien sinnvoll ein."
    },
    {
      icon: <UserCheck className="h-8 w-8 text-purple-500" />,
      title: "Persönliche Betreuung",
      description: "Direkter Kontakt zu den Entwicklern, keine anonymen Projektmanager."
    },
    {
      icon: <Settings className="h-8 w-8 text-teal-500" />,
      title: "Kein Fließband",
      description: "Jedes Projekt ist einzigartig. Wir entwickeln individuelle Lösungen statt Standardware vom Fließband."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container">
        {/* Values */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Unsere <span className="text-blue-600">Werte</span>
          </h2>
          <p className="text-lg text-gray-600">
            Diese Prinzipien leiten uns in allem, was wir tun.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <Card key={index} className="border-0 shadow-lg bg-white h-full hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6 text-center h-full flex flex-col">
                <div className="flex justify-center mb-4">
                  {value.icon}
                </div>
                <h4 className="text-lg font-bold mb-3">{value.title}</h4>
                <p className="text-gray-600 text-sm flex-grow">{value.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StorySection; 